/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestCurveLiquidityPool extends Contract<ITestCurveLiquidityPool> {
  coins: Call<(_index: BigNumberish) => string, ITestCurveLiquidityPool>
  'coins(int128)': Call<(_index: BigNumberish) => string, ITestCurveLiquidityPool>
  'coins(uint256)': Call<(_index: BigNumberish) => string, ITestCurveLiquidityPool>
  get_virtual_price: Call<() => BigNumber, ITestCurveLiquidityPool>
  'get_virtual_price()': Call<() => BigNumber, ITestCurveLiquidityPool>
  underlying_coins: Call<(_index: BigNumberish) => string, ITestCurveLiquidityPool>
  'underlying_coins(int128)': Call<(_index: BigNumberish) => string, ITestCurveLiquidityPool>
  'underlying_coins(uint256)': Call<(_index: BigNumberish) => string, ITestCurveLiquidityPool>
}

let ITestCurveLiquidityPoolBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestCurveLiquidityPoolBytecode = '0x';
}

// prettier-ignore
export const ITestCurveLiquidityPool = contract<ITestCurveLiquidityPool>(ITestCurveLiquidityPoolBytecode)`
  function coins(int128 _index) view returns (address asset_)
  function coins(uint256 _index) view returns (address asset_)
  function get_virtual_price() view returns (uint256 price_)
  function underlying_coins(int128 _index) view returns (address asset_)
  function underlying_coins(uint256 _index) view returns (address asset_)
`;